import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PageTitle from 'component/PageTitle';
import FullHeightLayout from 'layout/FullHeightLayout';
import { ReactComponent as ErrorClose } from 'assets/image/icons/error_close.svg';

const ServerError: React.FC = () => {
  PageTitle('サーバーエラー');

  return (
    <FullHeightLayout center className="error-504">
      <div className="error-504-wrapper">
        <div className="error-504__close-icon">
          <ErrorClose />
        </div>
        <h2 className="error-504__title">
          タイムアウトが
          <br />
          発生しました
        </h2>
        <p className="error-504__text">
          「トップへ戻る」ボタンから
          <br />
          やり直してください。
        </p>
        <RouterLink to="/" className="error-504__return">
          トップへ戻る
        </RouterLink>
      </div>
    </FullHeightLayout>
  );
};

export default ServerError;
